<template>
  <div class="text-sm xl:text-base">
    <div class="absolute inset-0 flex items-center justify-center">
      <swiper :pagination="{ clickable: true }" loop :autoplay="{ delay: 30000 }" class="w-full h-full">
        <swiper-slide class="disclaimer">
          <div class="absolute inset-0">
            <img src="images/ROOF_TOP_VIEW_FINAL.jpg" srcset="images/ROOF_TOP_VIEW_FINAL.jpg 1x, images/ROOF_TOP_VIEW_FINAL@2x.jpg 2x" class="object-cover w-full h-full" alt="">
          </div>
        </swiper-slide>
        <swiper-slide class="flex disclaimer">
          <div class="relative flex-1">
            <div class="absolute inset-0">
              <img src="images/escent.jpg" srcset="images/escent.jpg 1x, images/escent@2x.jpg 2x" class="object-cover w-full h-full" alt="">
            </div>
          </div>
          <div class="relative flex-shrink-0 w-2/5 px-12 py-20 text-white bg-cover xl:px-16 xl:py-24 xl:w-1/3 2xl:w-1/4">
            <div class="absolute inset-0">
              <img src="images/1420602380-huge-half-v.jpg" srcset="images/1420602380-huge-half-v.jpg 1x, images/1420602380-huge-half-v@2x.jpg 2x" class="object-cover object-left-top w-full h-full" alt="">
              <div class="absolute inset-x-0 bottom-0">
                <img src="images/pattern-02.png" srcset="images/pattern-02.png 1x, images/pattern-02@2x.png 2x" class="object-cover w-full h-full" alt="">
              </div>
            </div>
            <div class="relative space-y-4 xl:space-y-8">
              <h1 class="mb-16 text-3xl font-bold uppercase xl:text-4xl xl:mb-32">
                A BETTER LIVING<br>
                FOR ALL
              </h1>

              <p class="text-xl font-bold">
                อีกครั้ง กับชีวิตที่ดียิ่งกว่า...
              </p>
              <p>
                เอสเซ็นท์ หาดใหญ่ คอนโดมิเนียม 36 ชั้น
                ติดศูนย์การค้าเซ็นทรัล เฟสติวัล หาดใหญ่
              </p>
              <p>
                ด้วยประสบการณ์ใหม่กับการอยู่อาศัยแนวสูง
                Facility ครบครันในทุกส่วนของโครงการ
                สร้างความสุขให้ทุกความสะดวกสบาย
                มาอยู่ใกล้ ได้มากกว่าเคย
              </p>
              <p>
                ด้วยแนวคิด Genetic Diversity ที่มีการ
                ผสมผสานของวัฒนธรรมอันหลากหลาย
                ในเมืองหาดใหญ่เป็นศูนย์กลางของธุรกิจ
                ในดินแดนภาคใต้ ที่ผสมผสานความลงตัว
                ของการอยู่อาศัยไว้ร่วมกัน
              </p>
            </div>
          </div>
        </swiper-slide>

        <swiper-slide class="grid grid-cols-2 grid-rows-2 disclaimer">
          <div class="relative">
            <img src="images/Stocksy_txp8616fcd4VNc100_Medium_908342.jpg" alt="" class="absolute inset-0 object-cover w-full h-full">
          </div>
          <div class="relative">
            <img src="images/Stocksy_txpc7e732ffQpO200_OriginalDelivery_1438870.jpg" alt="" class="absolute inset-0 object-cover w-full h-full">
          </div>
          <div class="relative grid p-8 text-center text-white bg-white xl:p-12 place-items-center">
            <div class="absolute inset-0 overflow-hidden">
              <img src="images/1420602380-huge.jpg" srcset="images/1420602380-huge.jpg 1x, images/1420602380-huge@2x.jpg 2x" alt="" class="absolute inset-0 object-cover w-full h-full">
            </div>
            <div class="relative space-y-4 2xl:max-w-md 2xl:space-y-8 place-items-center">
              <h1 class="text-xl font-bold uppercase xl:text-3xl">
                Convenience<br>
                Comfort<br>
                Connected
              </h1>
              <h2 class="text-lg font-bold xl:text-2xl">
                ให้ชีวิต ต่อติดทุกความสะดวกสบาย
              </h2>
            </div>
          </div>
          <div class="relative overflow-hidden">
            <img src="images/shutterstock_663503203_cropped.jpg" srcset="images/shutterstock_663503203_cropped.jpg 1x, images/shutterstock_663503203_cropped@2x.jpg 2x" alt="" class="absolute inset-0 object-cover w-full h-full">
          </div>
        </swiper-slide>

        <swiper-slide class="grid grid-cols-2 grid-rows-2 disclaimer">
          <div class="relative row-span-full">
            <img src="images/shutterstock_1478142704.jpg" srcset="images/shutterstock_1478142704.jpg 1x, images/shutterstock_1478142704@2x.jpg 2x" class="object-cover w-full h-full" alt="" style="object-position: 15% 50%">
          </div>
          <div class="relative overflow-hidden">
            <img src="images/1.jpg" alt="" srcset="images/1.jpg 1x, images/1@2x.jpg 2x" class="absolute inset-0 object-cover w-full h-full">
          </div>
          <div class="relative grid p-8 text-center text-white bg-cover xl:p-12 place-items-center">
            <div class="absolute inset-0 w-full h-full overflow-hidden">
              <img src="images/1420602380-huge.jpg" srcset="images/1420602380-huge.jpg 1x, images/1420602380-huge@2x.jpg 2x" alt="" class="absolute inset-0 object-cover w-full h-full">
            </div>
            <div class="relative space-y-4 2xl:max-w-md 2xl:space-y-8 place-items-center">
              <h1 class="text-xl font-bold uppercase xl:text-3xl">
                Live colorfully<br>
                Live beautifully
              </h1>
              <h2 class="text-lg font-bold tracking-tighter xl:text-2xl">
                สีสัน และความงามของการใช้ชีวิต เกิดขึ้นได้ที่นี่...
              </h2>
              <p>
                ความงามของศิลปะที่ประณีตบรรจง สร้างงาน
                สถาปัตยกรรมที่มีความทันสมัยแบบเรียบง่าย
                ถ่ายทอดผ่านเส้นสายอย่างตรงไปตรงมา
                แต่ยังผสานลวดลายของศิลปะในอดีต
                ในรายละเอียดของอาคารไว้ร่วมกัน สร้างสีสัน
                และเกิดเป็นความงามของการใช้ชีวิต ได้อย่างลงตัว
              </p>
            </div>
          </div>
        </swiper-slide>
      </swiper>
    </div>
  </div>
</template>

<script>
import SwiperCore, { Pagination, Autoplay, Lazy } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/vue'

SwiperCore.use([
  Pagination,
  Autoplay,
  Lazy,
])

export default {
  name: 'ProjectConcept',
  components: {
    Swiper,
    SwiperSlide,
  },
}
</script>
